module.exports = __webpack_public_path__ + "460e4aaf6cc50e2eacbda3b0872c0b1d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/signinLogo.png
// module id = 887
// module chunks = 66